export const environment = {
  production: true,
  env: 'staging',
  version: '4.1.1',
  apiUrl: 'https://staging-api.teamtoolsapp.com',
  homeUrl: 'https://staging.teamtoolsapp.com',
  cacheUrl: 'https://teamtools-staging.firebaseio.com',
  chargebeeSite: 'teamtools-test',
  intercomAppId: 'c47lz76y',
  firebase: {
    // Staging Firebase config
    apiKey: 'AIzaSyAjtf686vGcqiELlI6ZSpcpnTLuyF8yg9E',
    authDomain: 'teamtools-staging.firebaseapp.com',
    databaseURL: 'https://teamtools-staging.firebaseio.com',
    projectId: 'teamtools-staging',
    storageBucket: 'teamtools-staging.appspot.com',
    messagingSenderId: '220797930601',
    appId: '' // Not provided in old codebase
  }
};